import { AiImageGenerationModel } from '../../tools/models/ai-image-generation';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../../../../shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { FileUpload } from '../../../../../contributor/components/profile/contributors/pack/models/pack';
import { BackgroundRemovalModel, BackgroundRemovalResponseModel } from '../../tools/models/background-remover';
import { ImageCaptionGeneratorRequestModel, ImageCaptionGeneratorResponseModel } from '../../tools/models/caption-generator';
import { ResizeImageRequestModel, ResizeImageResponseModel } from '../../tools/models/resize-image-model';
import { MergeImageRequestModel, MergeImageResponseModel } from '../../tools/models/merge-image';
import { MergeGridRequestModel, MergeGridResponseModel } from '../../tools/models/merge-grid';
import {  ImageUpScalarRequestModel, ImageUpScalarResponseModel } from '../models/image-enhancer';
import { ImagePlagiarismCheckerRequestModel, ImagePlagiarismCheckerResponseModel } from '../models/image-plagiarism-checker';
import { ImageColorizeRequestModel, ImageColorizeResponseModel } from '../models/image-colorize';


@Injectable({
  providedIn: 'root'
})
export class AiService extends BaseService {

  constructor(private http: HttpClient) {
    super();
   }

  generateAiImages(aiImageGenerationModel: AiImageGenerationModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    formData.append('prompt', aiImageGenerationModel.prompt || '');
    if (aiImageGenerationModel.reference_image ) {
      fileUpload.file = aiImageGenerationModel.reference_image ;
      fileUpload.name = aiImageGenerationModel.reference_image .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
      // formData.append('width', aiImageGenerationModel.width?.toString() || '');
      // formData.append('height',aiImageGenerationModel.height?.toString() || '');
      formData.append('pattern',aiImageGenerationModel.pattern?.toString() || '');

    }
    var route = `${this.baseUrl}/generate-images`;
    return this.http.post<string[]>(route, formData);
  }

  removeBackgroundImage(model: BackgroundRemovalModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    if (model.image ) {
      fileUpload.file = model.image ;
      fileUpload.name = model.image .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/remove-background-image`;
    return this.http.post<BackgroundRemovalResponseModel>(route, formData);
  }

  generateImageCaption(model: ImageCaptionGeneratorRequestModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    if (model.image ) {
      fileUpload.file = model.image ;
      fileUpload.name = model.image .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/generate-image-caption`;
    return this.http.post<ImageCaptionGeneratorResponseModel>(route, formData);
  }

  resizeImage(model: ResizeImageRequestModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    formData.append('target_width', model.target_width.toString() || '');
    formData.append('target_height', model.target_height.toString() || '');
    formData.append('maintain_aspectratio', model.maintain_aspectratio.toString() || '');
    if (model.image ) {
      fileUpload.file = model.image ;
      fileUpload.name = model.image .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/resize-image`;
    return this.http.post<ResizeImageResponseModel>(route, formData);
  }

  mergeImage(model: MergeImageRequestModel) {

    const formData = new FormData();
    formData.append('orientation', model.orientation.toString() || '');
    if (model.images && model.images.length > 0) {
      model.images.forEach((file, index) => {
        const fileName = file.name || `image_${index + 1}`;
        formData.append('images', file, fileName);
      });
    }
    var route = `${this.baseUrl}/merge-image`;
    return this.http.post<MergeImageResponseModel>(route, formData);
  }

  mergeGrid(model: MergeGridRequestModel) {

    const formData = new FormData();
    formData.append('cols', model.cols.toString() || '0');
    formData.append('rows', model.rows.toString() || '0');
    formData.append('spacing', model.spacing.toString() || '10');
    formData.append('margin', model.margin.toString() || '20');
    if (model.images && model.images.length > 0) {
      model.images.forEach((file, index) => {
        const fileName = file.name || `image_${index + 1}`;
        formData.append('images', file, fileName);
      });
    }
    var route = `${this.baseUrl}/merge-grid-images`;
    return this.http.post<MergeGridResponseModel>(route, formData);
  }

  imageUpscalar(model: ImageUpScalarRequestModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    if (model.file) {
      fileUpload.file = model.file ;
      fileUpload.name = model.file .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/image-upscaler`;
    return this.http.post<ImageUpScalarResponseModel>(route, formData);
  }

  imagePlagiarismChecker(model: ImagePlagiarismCheckerRequestModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    if (model.file) {
      fileUpload.file = model.file ;
      fileUpload.name = model.file .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/image-plagiarism-checker`;
    return this.http.post<ImagePlagiarismCheckerResponseModel>(route, formData);
  }

  imageColorize(model: ImageColorizeRequestModel) {
    var fileUpload=new FileUpload();
    const formData = new FormData();
    if (model.file) {
      fileUpload.file = model.file ;
      fileUpload.name = model.file .name || '';
      formData.append('files', fileUpload.file, fileUpload.name);
    }
    var route = `${this.baseUrl}/image-colorize`;
    return this.http.post<ImageColorizeResponseModel>(route, formData);
  }

}
